import { apiClient } from '@api/apiClient';
import { V4ApiResponse } from '@api/types';
import { buildChangeTrackingRequestConfig } from '@changeTracking/utils/buildChangeTrackingHeaders';
import { CHANGE_TRACKING_SOURCES } from '@changeTracking/utils/changeTrackingRegistry';
import { ToastType } from '@components/Toast';
import { UploadedPricingApiResponse } from '@store/customers/customerDetails/pricingTab';
import { createError } from '@utils/errorUtils';
import { handleToast } from '@utils/utils';

export async function togglePricing(payload: {
  CustomerId: number;
  Enabled: boolean;
}) {
  try {
    const res: V4ApiResponse<boolean> = await apiClient.post(
      'Customer/togglepricing',
      payload,
      buildChangeTrackingRequestConfig([
        CHANGE_TRACKING_SOURCES.customerDetails.pricingToggle,
      ]),
    );
    return res;
  } catch (error: unknown) {
    const e = createError(error, 'Failed to toggle pricing');
    handleToast(ToastType.Error, e.message);
  }
}

export async function fetchUploadedPricing(customerId: number) {
  try {
    const response: V4ApiResponse<UploadedPricingApiResponse> =
      await apiClient.get(`Customer/getuploadedpricing/${customerId}`);
    return response;
  } catch (error: unknown) {
    const e = createError(error, 'Failed to fetch uploaded pricing');
    handleToast(ToastType.Error, e.message);
  }
}

export async function fetchPricingEnabled(customerId: number) {
  try {
    const response: V4ApiResponse<boolean> = await apiClient.get(
      `/FeatureFlag/ispricingenabled/${customerId}`,
    );
    return response;
  } catch (error: unknown) {
    const e = createError(error, 'Failed to fetch pricing enabled');
    handleToast(ToastType.Error, e.message);
  }
}

export const uploadPricingSheet = async (id: string, file: File) => {
  try {
    const formData = new FormData();
    formData.append('formFile', file);
    const res: V4ApiResponse<null> = await apiClient.post(
      `Customer/uploadpricingsheet/${id}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...buildChangeTrackingRequestConfig([
            CHANGE_TRACKING_SOURCES.customerDetails.pricingUpload,
          ])?.headers,
        },
      },
    );
    return res;
  } catch (error: unknown) {
    const e = createError(error, 'Failed to upload pricing sheet');
    handleToast(ToastType.Error, e.message);
  }
};
